import { createStore } from 'zustand';

const IMAGE_SERVICE_URL = 'https://image-manager.sourceflow.co.uk';

export const createImageStore = (image, page) =>
  createStore((set) => ({
    dataUrl: image?.url || '',
    filename: image?.filename || '',
    fileType: undefined,
    originalFilename: image?.filename || undefined,
    page: page || 0,

    setDataUrl: (dataUrl) => set({ dataUrl }),
    setFilename: (filename) => set({ filename }),
    setFileType: (fileType) => set({ fileType }),
    setOriginalFilename: (originalFilename) => set({ originalFilename }),
    setPage: (page) => set({ page }),
    setImageStore: (allProps) =>
      set((state) => ({
        ...state,
        ...allProps,
      })),
  }));

const httpRequest = async (url, options = {}) => {
  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  try {
    if (options.queryParams) {
      const queryParams = new URLSearchParams(options.queryParams);
      url = url + '?' + queryParams.toString();
    }

    const response = await fetch(url, { headers: defaultHeaders, ...options });

    if (!response.ok) {
      throw new Error(`Failed to make a fetch request: ${response.status} (${response.url})`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

export const getAuthToken = async () => {
  const response = await httpRequest('/_sf/api/v1/auth_tokens.json', {
    method: 'POST',
    body: JSON.stringify({
      scope: ['image/upload', 'image/delete'],
    }),
  });
  const data = await response;

  if (!data.token) {
    throw new Error('Authentication token not found in response');
  }

  return data.token;
};

export const getImages = async (authorizationToken, size) => {
  const options = {
    method: 'GET',
    headers: {
      authorization: `Bearer ${authorizationToken}`,
    },
    queryParams: {
      size,
    },
  };

  const response = await httpRequest(`${IMAGE_SERVICE_URL}/api/v1/images`, options);
  const data = await response;

  if (data.error) {
    throw new Error(data.error);
  }

  return data;
};

export const uploadImage = async (authorizationToken, base64, filename) => {
  const response = await httpRequest(`${IMAGE_SERVICE_URL}/api/v1/images/upload`, {
    method: 'POST',
    headers: {
      authorization: `Bearer ${authorizationToken}`,
    },
    body: JSON.stringify({
      image_name: filename,
      image: base64,
    }),
  });
  const data = await response;

  if (data.error) {
    throw new Error(data.error);
  }

  return data;
};

export const deleteImage = async (authorizationToken, imageId) => {
  const response = await httpRequest(`${IMAGE_SERVICE_URL}/api/v1/image/${imageId}`, {
    method: 'DELETE',
    headers: {
      authorization: `Bearer ${authorizationToken}`,
    },
  });
  const data = await response;

  if (data.error) {
    throw new Error(data.error);
  }

  return data;
};

export const authorisedGetImages = async () => {
  const token = await getAuthToken();
  return getImages(token);
};

export const authorisedUploadImage = async (base64, filename) => {
  const token = await getAuthToken();
  return uploadImage(token, base64, filename);
};

export const FIFTEEN_MINUTES = 15 * 60 * 1000;
